<template>
  <div class="container-pay-BR" :style="`paddingTop:${barHeight}px`">
    <van-nav-bar class="van-bar" :title="$t('lang.pay.store')" left-arrow @click-left="closeWeb">
      <template #left>
        <img class="left-nav" src="@/assets/packageAssets/common/arrow05.png" alt="" @click-left="closeWeb" />
      </template>
      <template #right>
        <div class="coin arTitRight15 arRightRound">
          <img class="arLeftM5" :src="getMatchImg('coin')" alt="" />
          <i>{{ userInfo.coinsNum }}</i>
        </div>
      </template>
    </van-nav-bar>

    <div class="main" v-if="!loadingFlag">
      <!-- 统一之后的样式 -->
      <div v-if="promotionalGoods" class="discount-box" :class="{ loseSelect: selectGid != promotionalGoods.gid }" @click="handleSelete(promotionalGoods)">
        <div class="add-money" :class="{ addRight: promotionalGoods.discountType == 2 }">
          <div class="add">
            <div class="add-box">
              <div class="add-discount">{{ promotionalGoods.discount }}</div>
              <img class="add-box-bg" src="@/assets/packageAssets/views/P1_Boys/PayStore/vava/arrow_yellow.png" alt="" />
            </div>
          </div>
          <div class="money">
            <img class="icon-money" :src="getMatchImg('coins')" alt="" />
            <span>{{ promotionalGoods.amount }}</span>
          </div>
        </div>
        <div class="method">
          <div class="method-icon">
            <img class="icon-discount" :src="promotionalGoods.icon | imgPath" alt="" />
            {{ promotionalGoods.goodDesc }}
          </div>
          <div class="num">{{ promotionalGoods.currency }}{{ promotionalGoods.brlPrice / 100 }}</div>
        </div>
      </div>
      <div class="title">{{ $t('lang.payPT.selectAmount') }}</div>

      <!-- 选择充值金额 -->
      <div class="recharge">
        <div class="option" :class="{ selectAct: selectGid == item.gid }" v-for="item in rechargeList" :key="item.gid" @click="handleSelete(item)">
          <div class="option-top">
            <img v-if="item.label" class="best-img" :src="item.label | imgPath" alt="" />
            <img class="money-img" :src="getMatchImg('coin')" alt="" />
            <span>{{ item.amount }}</span>
          </div>
          <!-- 第二次处理 只保留描述带vip的 -->
          <div class="discount-num" v-if="item.goodDesc">
            <template v-for="desc in handleTipsFormat(item.goodDesc)">
              <div class="discount-num-tips" :key="desc">
                <template v-if="desc.indexOf('videopass') !== -1">
                  <span>+{{ desc.replace('videopass', '') }}&nbsp;</span>
                  <img :src="getMatchImg('video-pass')" width="13" height="12" />
                </template>
                <template v-else-if="desc.indexOf('coin') !== -1">
                  <span>+{{ desc.replace('coin', '') }}&nbsp;</span>
                  <img :src="getMatchImg('coin')" width="13" height="12" />
                </template>
                <template v-else>
                  <span>+{{ desc }}</span>
                </template>
              </div>
            </template>
          </div>
        </div>
      </div>

      <!--第一种 折扣的价格 有资格的才会看的到  和上面的价格一样 可以选择 -->
      <!--第二种 自然量用户充值补贴 这是一张图片 -->
      <div class="title">{{ $t('lang.wd.methodTit') }}</div>

      <!-- 优惠卷入口 -->
      <CouponEnter @openCouponPop="openCouponPop" :maxCoupon="maxCoupon" :styleType="'for-vava'"></CouponEnter>

      <!-- 支付方式 -->
      <div
        v-for="(item, index) in payMothods"
        :key="item.id"
        :class="['method-item', loadingShow ? 'activeLoading' : '', disClassFn(item.desc, packageName)]"
        @click="selectPayMothod(item, index)"
      >
        <MyPLabel class="discount" v-if="item.desc" :str="item.desc" :customClass="{ coin: 'discount-coins' }" />
        <div class="method-con">
          <div class="img-name" :class="{ noClick: loadingShow }">
            <img :src="item.icon | imgPath" alt="" />
            <i class="line"></i>
            <span>{{ item.name }}</span>
          </div>

          <div class="money-num" :class="{ noClick: loadingShow }">
            <div class="money-discount-price">
              <i :class="{ actTextColor: loadingShow && item.name == selectPayName }">{{ item.currency }}</i>
              <span :class="{ actTextColor: loadingShow && item.name == selectPayName }">{{ handleDiv100(item.price) }}</span>
              <van-loading v-if="loadingShow && item.name == selectPayName" type="spinner" color="#FFFFFF" class="pay-loading" size="20px" />
            </div>
          </div>
        </div>
      </div>

      <!-- 不走接口-从客户端取 -->
      <GooglePay
        v-if="googleData[0]"
        :class="{ noClick: loadingShow }"
        :loadingShow="loadingShow"
        :googlePrice="googleData[0].price"
        :currency="googleData[0].currencyCode"
        :styleType="'for-vava'"
        @googlePay="googlePay"
      />
    </div>

    <!-- 页面加载动画 -->
    <content-loader v-else :width="400" :height="900" />

    <!-- 支付结果弹窗 -->
    <PayResult :showDiaC="showResultDia" :oneShow="true" :title="payResultText" />

    <!-- 优惠劵列表popup -->
    <CouponPopup
      v-if="validCouponListSort"
      :active="popActive"
      :showCouponPopup="showCoupon"
      :tebTit="tebTit"
      @close="closePop"
      :maxCoupon="maxCoupon"
      :styleType="`for-${packageName}`"
      :validCouponListSort="validCouponListSort"
      :expiredCouponList="expiredCouponList"
      @confirmChooseCouponId="confirmChooseCouponId"
    />
  </div>
</template>

<script>
// 商城
import { apiFetchBuyCoinsList, apiFetchPayList, apiFetchUserInfo, apiFetchShopOrder, apiFetchCouponList } from '@/api/imee'
import { mixin } from '@/mixin/index.js'

import CCouponEnter from '@/components/CCouponEnter'
import CCoupon from '@/components/CCoupon'
import GooglePay from '../Pay/component/GooglePay.vue'
import PayResult from '@/components/CConfirm/PayResult.vue'

import _debounce from 'lodash/debounce'

export default {
  mixins: [mixin],
  components: {
    CouponEnter: CCouponEnter,
    CouponPopup: CCoupon,
    GooglePay,
    PayResult
  },
  data() {
    let query = this.$route.query
    return {
      barHeight: query.statusBarHeight || 38,
      scene: query.scene || null,
      thirdParam: query.thirdParam || null,
      fromCouponId: query.couponRecordId || null,
      userInfo: {},
      rechargeList: [],
      selectGid: null,
      selectProductId: null,
      googleData: {},
      googlePayList: [],
      payMothods: [],
      payType: '',
      payFlag: false,
      loadingShow: false, //请求加载中

      // 优惠的价格 有资格的才看得到
      promotionalGoods: null,
      loadingFlag: false,
      selectPayName: null,
      productIdList: [],
      amountItem: null,
      // 支付方式统计
      selectChannelIndex: -1
    }
  },
  watch: {
    validCouponList: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.fatchMaxCoupon(this.amountItem, newVal)
        }
      }
    }
  },
  computed: {
    // 处理商品底下的小字格式化
    handleTipsFormat() {
      return (value) => {
        if (!value) {
          return []
        } else {
          const newArr = value.split('+')
          const finalArr = newArr.filter((v) => !!v)
          return finalArr
        }
      }
    }
  },
  methods: {
    disClassFn(desc, packageName) {
      if (desc) {
        let className = ''
        switch (packageName) {
          case 'vava':
            className = 'has-dis-green'
            break
          case 'echo':
          case 'joychat':
            className = 'has-dis-lightgreen'
            break
          default:
            className = 'has-dis-green'
        }
        return className
      }
      return ''
    },
    // 刷新 客户端 store谷歌支付完成会调用这个优惠劵  获得最新的优惠劵
    refresh() {
      this.fetchUserInfo()
      this.fetchCouponList(0) // 获取有效优惠劵
      this.buyCoinsList()
    },

    // 数据处理 当 propType == 0 的时候 amount = amount+number
    handleAmount(item) {
      if (item.presentPropList && item.presentPropList.length > 0) {
        let obj = item.presentPropList.find((le) => le.propType == 0)
        if (obj != undefined) {
          return item.amount + obj.number
        }
        return item.amount
      }
      return item.amount
    },

    // 整数/100 保留两位小数 后面补零
    returnFloat(val) {
      let num = val / 100
      if (('' + val).slice(-2) == '00') {
        return num + '.00'
      }
      if (('' + val).slice(-1) == '0') {
        return num + '0'
      }
      return num
    },

    // 获取个人信息
    fetchUserInfo() {
      apiFetchUserInfo().then((res) => {
        if (res) {
          this.userInfo = res
        }
      })
    },
    // 复制id
    copy(id) {
      this.handleCopy(id, this.$t('lang.msgCopySuccss'))
    },

    // 选择充值金额
    handleSelete(item) {
      this.fatchMaxCoupon(item)
      this.amountItem = item
      this.$client.addEvent('top_up', { Action: 'Click', APosition: 'goods', AValue: item.gid, goodtype: 'coin', productID: item.gid, from: 'webstore' })
      this.selectGid = item.gid
      this.selectProductId = item.productId
      this.payMothods = item.channels
      if (this.payMothods && this.payMothods.length > 0) {
        this.payType = this.payMothods[0].payType
      }
      this.fetchGoogleData()
    },

    // 选择付款方式
    selectPayMothod(item, index) {
      this.payType = item.payType
      this.selectPayName = item.name
      this.selectChannelIndex = index
      this.handlePay(item)
    },

    // 支付
    handlePay: _debounce(
      function (item, cpf) {
        let payChannelTotal = null
        if (this.payMothods && this.payMothods.length) {
          payChannelTotal = this.payMothods.length
        }
        let payChannelIndex = null
        if (this.selectChannelIndex != -1 && payChannelTotal !== null && payChannelTotal !== 0) {
          payChannelIndex = payChannelTotal - 1 - this.selectChannelIndex
        }
        if (this.googleData && this.googleData[0] && payChannelTotal !== null && payChannelIndex !== null) {
          payChannelTotal = payChannelTotal + 1
          payChannelIndex = payChannelIndex + 1
        }

        this.$client.addEvent('top_up', {
          Action: 'Click',
          APosition: 'payButton',
          productID: this.selectGid,
          goodtype: 'coin',
          from: 'webstore',
          paymethod: this.selectMethod
        })
        let data = {
          gid: this.selectGid,
          payType: this.payType,
          scene: this.scene || 'WebStore',
          thirdParam: this.thirdParam,
          shopType: 5,
          payChannel: this.selectPayName,
          payChannelIndex: payChannelIndex,
          payChannelTotal: payChannelTotal
        }
        if (this.$route.query.videoChatScene) {
          data.videoChatScene = this.$route.query.videoChatScene
        }
        // 2.14日汪黎明新说：增加activityType参数，下单时传入
        if (this.$route.query.activityType) {
          data.activityType = this.$route.query.activityType
        }
        if (this.maxCoupon) {
          data.couponRecordId = this.maxCoupon.couponRecordId
        }
        this.loadingShow = true

        apiFetchShopOrder(data)
          .then((res) => {
            this.fetchCouponList(0) // 获取有效优惠劵
            if (res) {
              this.order = res.credential && res.credential.wapUrl
              if (res.credential.openInExternalBrowser) {
                let url = 'iMee://open_web_outside?url=' + res.credential.wapUrl
                commandRouter.postMessage(url)
              } else {
                if (this.order) {
                  this.$router.push({
                    path: '/pay-code',
                    query: {
                      url: this.order
                    }
                  })
                }
              }
            }
          })
          .catch(() => {})
          .finally(() => {
            this.loadingShow = false
          })
      },
      2000,
      {
        leading: true,
        trailing: false
      }
    ),

    // 获取金额列表
    buyCoinsList() {
      const resolveCoinsList = (res, cb) => {
        this.rechargeList = res.goods
        this.gidBx = res.goods[0].gid
        this.processData(res.goods[0] && res.goods[0].channels)

        // productIdList 要传给客户端 验证各个档位是否有google支付
        res.goods.forEach((i) => {
          this.productIdList.push(i.productId)
        })
        this.$client.googleProductList(this.productIdList)

        // 客户端优惠卷点击进来锁定价格 默认第一个
        if (this.fromCouponId && this.validCouponList.length > 0) {
          let couponData = this.validCouponList.filter((item) => {
            return item.couponRecordId == this.fromCouponId
          })
          let goodData = res.goods.find((i) => {
            return i.amount >= couponData[0].minUseAmount
          })
          this.selectGid = goodData.gid
          this.selectProductId = goodData.productId
          this.fatchMaxCoupon(goodData)
          this.amountItem = goodData
        }
        // 其他
        else {
          this.selectGid = res.goods[0].gid
          this.selectProductId = res.goods[0].productId
          this.fatchMaxCoupon(res.goods[0])
          this.amountItem = res.goods[0]
        }

        cb && cb()
      }

      this.productIdList = []
      this.loadingFlag = true

      // 读取web localstorage缓存
      const localRes = window.localStorage.getItem('buyCoinsList')
      if (localRes) {
        resolveCoinsList(JSON.parse(localRes), () => {
          this.payList(this.selectGid)
        })
      }

      // 加个参数 scene
      apiFetchBuyCoinsList({
        scene: this.scene
      }).then((res) => {
        if (res && res.goods && res.goods.length > 0) {
          // 写入web localstorage缓存
          window.localStorage.setItem('buyCoinsList', JSON.stringify(res))
          resolveCoinsList(res, () => {
            this.payList(this.selectGid)
          })
        }
      })
    },

    // 获取支付列表
    payList(id) {
      const resolvePayList = (res) => {
        this.payMothods = res.payChannelList
        if (this.payMothods && this.payMothods.length > 0) {
          this.payType = this.payMothods[0].payType
        }
        this.loadingFlag = false
      }

      // 读取web localstorage缓存
      const localRes = window.localStorage.getItem('payChannelList')
      if (localRes) {
        resolvePayList(JSON.parse(localRes))
      }

      // 读取接口数据
      if (!id) {
        return
      }
      let params = {
        gid: id,
        shopType: 5,
        scene: 'WebStore'
      }
      apiFetchPayList(params).then((res) => {
        if (res && res.payChannelList) {
          // 写入web localstorage缓存
          window.localStorage.setItem('payChannelList', JSON.stringify(res))

          resolvePayList(res)
        }
      })
    },

    // 关闭结果弹窗
    cancelAgain() {
      this.showResultDia = false
      this.fetchUserInfo()
    },

    // 验证google支付返回的数据
    queryGoogleProductListCallback(res) {
      if (res) {
        this.googlePayList = JSON.parse(res)
        this.fetchGoogleData()
      }
    },

    // 点击价格 查找google pay数据
    fetchGoogleData() {
      if (this.selectProductId) {
        this.googleData = this.googlePayList.filter((item) => {
          return this.selectProductId == item.productId
        })
      }
    },

    // 调谷歌的时候需要客户端提供方法 支付完成 客户端会调用我的refresh方法来刷新优惠劵
    googlePay() {
      let params = {
        gid: this.selectGid,
        productId: this.googleData && this.googleData[0].productId,
        scene: this.scene || 'WebStore'
      }
      // 使用优惠券
      if (this.maxCoupon) {
        params.couponRecordId = this.maxCoupon.couponRecordId
      }
      payGoogleFromWeb.postMessage(JSON.stringify(params))
    }
  },
  created() {
    this.refresh()
    this.$client.addEvent('top_up', { Action: 'Popup', APosition: 'webStore', AValue: this.$route.query.scene })

    // this.googleData = [
    //   {
    //     price: '19.9'
    //   }
    // ]
  },
  mounted() {
    window.queryGoogleProductListCallback = this.queryGoogleProductListCallback
    window.refresh = this.refresh
  }
}
</script>
<style lang="scss" scoped>
img:not([src]) {
  opacity: 0;
}
.container-pay-BR {
  width: 100%;
  min-height: 100vh;
  background: #f7f6f9;
  padding-bottom: 80px;

  .coin {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 30px;
    padding: 0 10px;
    margin-right: -16px;
    background: #ffffff;
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.1);
    border-radius: 15px 0px 0px 15px;
    font-family: Inter;
    font-weight: 400;
    font-size: 11px;
    color: #333333;
    > img {
      display: inline-block;
      width: 18px;
      height: 18px;
      margin-right: 4px;
    }
    > i {
      font-weight: 600;
      font-size: 17px;
      color: #a338fc;
    }
  }

  .main {
    margin-top: 20px;
    padding: 0 18px;
    .recharge {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .option {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 48%;
        margin-bottom: 20px;
        padding: 12px 0;
        color: #666666;
        background: #ffffff;
        border-radius: 8px;
        box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
        .option-top {
          width: 100%;
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          .money-img {
            position: relative;
            top: 4px;
            right: 2px;
            width: 12px;
            height: 12px;
            margin: 0 2px;
          }
          > span {
            display: inline-block;
            margin-bottom: 2px;
            font-size: 24px;
            font-family: Inter;
            font-weight: 600;
          }
          .add {
            font-size: 12px;
            color: #ff0000;
          }
        }
        .discount-num {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          column-gap: 2px;
          font-family: Inter;
          font-weight: 500;
          font-size: 10px;
          color: #ff0000;
          line-height: 12px;
          text-align: center;
          > span {
            display: flex;
            align-items: center;
            img {
              width: 10px;
              height: 10px;
              margin-left: 2px;
            }
          }
          .discount-num-tips {
            display: flex;
            align-items: center;
            width: fit-content;
            justify-content: center;
            height: 16px;
            margin-right: 2px;
          }
        }
        .best-img {
          position: absolute;
          top: -12px;
          left: 0;
          width: 30px;
          height: 30px;
        }
      }
      .selectAct {
        color: #a338fc;
        outline: 2px solid #a338fc;
        border-radius: 8px;
      }
    }

    // 新样式
    .discount-box {
      position: relative;
      width: 100%;
      height: 66px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 20px;
      background: url('~@/assets/packageAssets/views/P1_Boys/PayStore/vava/discount_bg.png') no-repeat;
      background-size: 100% 100%;
      border-radius: 8px;
      box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.15);
      .add-money {
        flex: 1;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
      }
      .addRight {
        flex-direction: row-reverse;
        .add {
          .add-box {
            .add-discount {
              margin-left: 10px;
            }
            .add-box-bg {
              transform-origin: center center;
              transform: rotateY(180deg);
              -webkit-transform: rotateY(180deg);
              margin-left: 10px;
            }
          }
        }
      }
      .add {
        min-width: 98px;
        height: 50px;
        margin-right: 5px;
      }

      .add-box {
        position: relative;
        width: 100%;
        height: 100%;
        padding: 0 20px;
        text-align: center;
        line-height: 50px;
        font-family: Inter;
        font-weight: 600;
        font-size: 22px;

        .add-discount {
          width: 100%;
          height: 100%;
          text-align: center;
          position: absolute;
          top: 0;
          left: 0;
          z-index: 100;
          background: linear-gradient(41.47deg, #dc17f7 0%, #566bff 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }
        .add-box-bg {
          width: 100%;
          height: 100%;
          display: block;
          position: absolute;
          top: 0;
          left: 0;
          z-index: 50;
          background: url('~@/assets/packageAssets/views/P1_Boys/PayStore/vava/arrow_yellow.png') no-repeat;
          background-size: 100% 100%;
        }
      }

      .money {
        display: flex;
        align-items: center;
        font-family: Inter;
        font-weight: 600;
        font-size: 28px;
        color: #fff64e;
        text-shadow: 0px 1px 1px rgba(90, 58, 8, 0.5);
        .icon-money {
          width: 42px;
          height: 42px;
        }
      }
      .method {
        width: 82px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        font-family: Inter;
        font-weight: 400;
        font-size: 9px;
        line-height: 12px;
        text-align: right;
        font-style: normal;
        color: #fff6db;
        background: linear-gradient(0deg, #fff6db 0%, #fdc58b 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        .method-icon {
          display: flex;
          align-items: center;
          justify-content: center;
          > img {
            width: 12px;
            height: 12px;
            margin-right: 5px;
          }
        }
        .num {
          margin-top: 8px;
          font-size: 14px;
          text-align: center;
        }
      }
    }

    // 失去选择 优惠 置灰
    .loseSelect {
      // pointer-events: none;
      opacity: 0.5;
    }
    .title {
      height: 20px;
      margin-bottom: 16px;
      font-size: 16px;
      font-family: Inter, Inter;
      font-weight: 500;
      color: #333333;
      line-height: 20px;
    }

    .method-item {
      width: 100%;
      margin-bottom: 10px;
      border-radius: 10px;

      .discount {
        padding: 4px 10px;
        font-family: Outfit;
        font-size: 12px;
        font-weight: 400;
        line-height: 18px;
        text-align: center;
        color: #ffffff;
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
      }

      .method-con {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 56px;
        padding: 0 8px;
        background: #ffffff;
        border-bottom-left-radius: 10px;
        border-bottom-right-radius: 10px;
        font-size: 15px;
        font-family: Inter;
        font-weight: 600;

        .img-name {
          display: flex;
          align-items: center;
          > img {
            width: 54px;
            height: 32px;
            object-fit: contain;
          }
          > i {
            display: inline-block;
            height: 20px;
            margin: 0 5px;
            border-left: 1px solid #d8d8d8;
          }
          > span {
            color: #333333;
          }
        }
        .money-num {
          display: flex;
          align-items: center;
          font-size: 16px;
          > i {
            display: block;
            width: 20px;
            height: 20px;
            margin-left: 12px;
            border-radius: 50%;
            border: 0.5px solid #d8d8d8;
          }
        }
        .money-discount-price {
          position: relative;
          padding: 8px 5px;
          background: #424145;
          border-radius: 6px;
          color: #ffd786;
          font-family: Inter-Regular;
          text-align: center;
          > span {
            font-size: 15px;
          }
          > i {
            font-size: 8px;
          }
        }

        .pay-loading {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
        .actTextColor {
          opacity: 0.1;
        }

        .noClick {
          pointer-events: none;
          filter: grayscale(100%);
        }
      }
    }

    .has-dis-green {
      border: 1px solid #4caf50;
      .discount {
        background: #4caf50;
      }
    }

    .has-dis-lightgreen {
      border: 1px solid #2dcd90;
      .discount {
        background: #2dcd90;
      }
    }

    .activeLoading {
      pointer-events: none;
    }
  }
}

::v-deep .van-nav-bar__title {
  font-size: 17px;
  font-family: Inter-Bold, Inter;
  font-weight: bold;
  color: #333333;
}
</style>

<style>
.discount-coins {
  width: 14px;
  height: 14px;
}
</style>
